import React from "react";
import { Heart, Tag, Users } from "lucide-react";
import { IMAGES, buildWhatsAppLink } from "../constants";

const features = [
  {
    icon: Tag,
    title: "Tu nombre",
    desc: "Cada prenda lleva tu identidad bordada o sublimada con cuidado.",
  },
  {
    icon: Users,
    title: "Tu logo",
    desc: "Uniformes para deportes, escuelas, familias y celebraciones.",
  },
  {
    icon: Heart,
    title: "Tu fe",
    desc: "Diseños inspirados en devoción, raíces y la Virgen del Valle.",
  },
];

export default function ValueProposition() {
  return (
    <section
      id="propuesta"
      data-testid="value-proposition-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="img-zoom rounded-[2rem] overflow-hidden aspect-[4/5]">
            <img
              src="/bodys/grupo-2.jpeg"
              alt="Detalle prenda personalizada Vallitas"
              className="w-full h-full object-cover"
              data-testid="value-prop-image"
            />
          </div>
          <div className="mt-6 grid grid-cols-2 gap-4">
            <div className="img-zoom rounded-[1.5rem] overflow-hidden aspect-square">
              <img
                src="/tela.jpeg"
                alt="Detalle de tela"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="paper-card rounded-[1.5rem] p-6 flex flex-col justify-center">
              <div className="label-eyebrow mb-2">Hecho a mano</div>
              <p className="font-heading text-2xl leading-tight text-ink">
                Cada puntada es una <span className="italic text-vino">oración</span>.
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="label-eyebrow mb-5">Nuestra propuesta</div>
          <h2
            data-testid="value-prop-title"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.05]"
          >
            No es solo ropa,
            <br />
            es <span className="italic text-vino">lo que representas</span>.
          </h2>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-ink-soft max-w-2xl">
            Personalizamos cada prenda con tu nombre, el logo de tu marca, los
            colores de tu equipo o la devoción que llevas en el pecho. En
            Vallitas no vendemos confección en serie: vestimos historias.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-5">
            {features.map((f) => {
              const Icon = f.icon;
              return (
                <div
                  key={f.title}
                  data-testid={`feature-${f.title.toLowerCase().replace(/\s/g, "-")}`}
                  className="group p-6 rounded-[1.5rem] border border-line bg-page hover:bg-sand transition-colors"
                >
                  <div className="w-12 h-12 rounded-full bg-vino text-page flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                    <Icon size={20} />
                  </div>
                  <h3 className="font-heading text-2xl text-ink mb-2">
                    {f.title}
                  </h3>
                  <p className="text-sm text-ink-soft leading-relaxed">
                    {f.desc}
                  </p>
                </div>
              );
            })}
          </div>

          <a
            href={buildWhatsAppLink("Hola, me gustaría conocer las opciones de personalización.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="value-prop-cta"
            className="mt-10 inline-flex items-center gap-2 text-vino font-medium link-underline"
          >
            Cuéntame qué quieres personalizar →
          </a>
        </div>
      </div>
    </section>
  );
}
